import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import { useRef, useState } from "react";
import ProgressBar from "./ProgressBar";

import V1_Red from "./3D_irrigation_renders/V1_red.svg";
import V2_Red from "./3D_irrigation_renders/V2_red.svg";
import V3_Red from "./3D_irrigation_renders/V3_red.svg";
import V4_Red from "./3D_irrigation_renders/V4_red.svg";
import V5_Red from "./3D_irrigation_renders/V5_red.svg";
import V6_Red from "./3D_irrigation_renders/V6_red.svg";
import V7_Red from "./3D_irrigation_renders/V7_red.svg";
import V8_Red from "./3D_irrigation_renders/V8_red.svg";
import V9_Red from "./3D_irrigation_renders/V9_red.svg";
import V10_Red from "./3D_irrigation_renders/V10_red.svg";
import V11_Red from "./3D_irrigation_renders/V11_red.svg";
import V12_Red from "./3D_irrigation_renders/V12_red.svg";
import V13_Red from "./3D_irrigation_renders/V13_red.svg";
import V14_Red from "./3D_irrigation_renders/V14_red.svg";

import V1_Green from "./3D_irrigation_renders/V1_Green.svg";
import V2_Green from "./3D_irrigation_renders/V2_Green.svg";
import V3_Green from "./3D_irrigation_renders/V3_Green.svg";
import V4_Green from "./3D_irrigation_renders/V4_Green.svg";
import V5_Green from "./3D_irrigation_renders/V5_Green.svg";
import V6_Green from "./3D_irrigation_renders/V6_Green.svg";
import V7_Green from "./3D_irrigation_renders/V7_Green.svg";
import V8_Green from "./3D_irrigation_renders/V8_Green.svg";
import V9_Green from "./3D_irrigation_renders/V9_Green.svg";
import V10_Green from "./3D_irrigation_renders/V10_Green.svg";
import V11_Green from "./3D_irrigation_renders/V11_Green.svg";
import V12_Green from "./3D_irrigation_renders/V12_Green.svg";
import V13_Green from "./3D_irrigation_renders/V13_Green.svg";
import V14_Green from "./3D_irrigation_renders/V14_Green.svg";

const redImages = [
  null,
  V1_Red, V2_Red, V3_Red, V4_Red, V5_Red, V6_Red, V7_Red,
  V8_Red, V9_Red, V10_Red, V11_Red, V12_Red, V13_Red, V14_Red,
];

const greenImages = [
  null,
  V1_Green, V2_Green, V3_Green, V4_Green, V5_Green, V6_Green, V7_Green,
  V8_Green, V9_Green, V10_Green, V11_Green, V12_Green, V13_Green, V14_Green,
];

const ValveComponent = ({
  index,
  displayIndex,   // 👈
  isOn,
  chakId,
  romsAuto,
  scheduleAuto,
  onRefresh,        // 👈
  isPressureorFlow
}: {
  index: number;
  displayIndex: number;   // 👈
  isOn: boolean;
  chakId: number;
  romsAuto: boolean;
  onRefresh: () => void;   // 👈
  scheduleAuto: boolean;  // 👈
  isPressureorFlow : boolean;
 
}) => {
  const progressInterval = useRef<NodeJS.Timeout | null>(null);
  const [now, setNow]               = useState<number>(0);
  const [progressBar, setProgressBar] = useState<boolean>(false);

  const imageIndex = displayIndex + 1;  // 👈 V1 image/style use karega — display ke hisaab se
  const sovIndex   = index + 1;         // 👈 SOV command ke liye: SOV 3, SOV 4...

  const imgId    = `V${imageIndex}_Red`;                        // CSS id: V1_Red, V2_Red
  const btnClass = `V${String(imageIndex).padStart(2, "0")}`;  // V01, V02
  const isLine1 = index % 2 === 0;  // yeh sahi hai

  const imgSrc = isOn
    ? (greenImages[imageIndex] ?? V1_Green)
    : (redImages[imageIndex]  ?? V1_Red);

  // ── Progress bar ─────────────────────────────────────────────
  const startProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(0);
    const stepTime  = 250;
    const duration  = 25000;
    const increment = 100 / (duration / stepTime);
    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null;
      }
      setNow(current);
    }, stepTime);
  };

  const stopProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(0);
    setProgressBar(false);
  };

  // ── SOV command — ek hi API, response aaya toh band ──────────
  const changeSov = async () => {
    if (!scheduleAuto) {
      toast.error("Please select schedule manual mode");
      return;
    }

    if(isPressureorFlow){
       toast.error("Please select manual mode");
       return;
    }

    startProgressBar();
    setProgressBar(true);

    try {
      const res = await ApiService.axiosApi("Command/sov/open/close", {
        method: "POST",
        data: {
          deviceId:  chakId,
          sovNumber: sovIndex,  // 1…14
          onOff:    !isOn,       // true = open, false = close
        },
      });

      if (res.success) {
        toast.success("✅ SOV updated");
        setTimeout(() => {
          onRefresh();
      }, 600);
      } else {
        toast.error("Command failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("❌ Error");
    } finally {
      stopProgressBar();  // 👈 success ho ya fail — band karo
    }
  };

  // ── Render ───────────────────────────────────────────────────
  return (
    <>
      {progressBar && (
        <ProgressBar
          totalpage={0}
          pageNumber={0}
          now={now}
          mystyle={{
            position: "absolute",
            top: "-97px",
            bottom: 0,
            left: '-97px',
            height: "4px",
            width: "1138px",
            zIndex: 10,
            backgroundColor: "transparent",
            borderRadius: 0,
          }}
        />
      )}

      <img
        id={imgId}
        src={imgSrc}
        alt={btnClass}
      />

      <button
        onClick={changeSov}
        id={imgId}
        className={btnClass}
        title={`${btnClass} — ${isOn ? "ON" : "OFF"}`}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50px",
          top: "10px",
          marginLeft: isLine1 ? "5px" : "35px",
          padding: "0px",
          zIndex: 10,
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
          position: isLine1 ? "absolute" : undefined,
          cursor: romsAuto ? "not-allowed" : "pointer",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "35px",
            height: "20px",
            top: "50px",
            right:       isLine1 ? "75px" : undefined,
            paddingLeft: isLine1 ? undefined : "60px",
            zIndex: 4,
            fontSize: 11,
            fontWeight: 600,
            color: isOn ? "#16a34a" : "#dc2626",
          }}
        >
          {btnClass}
        </div>
      </button>
    </>
  );
};

export default ValveComponent;